(() => {
  const normalizeQuery = value => {
    const trimmed = value.trim();
    if (!trimmed || /[":*()\\]/.test(trimmed) || /\b(?:AND|OR|NOT)\b/.test(trimmed)) return trimmed;
    return trimmed.split(/\s+/u).map(word => `"${word}"`).join(' ');
  };
  document.addEventListener('input', event => {
    const input = event.target;
    const group = input.closest('[data-qf-filter-group]');
    if (!group || input.hasAttribute('data-qf-filter-extra') || input.type !== 'checkbox') return;
    group.querySelectorAll('[data-qf-filter-extra]').forEach(extra => { extra.checked = input.checked; });
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-qf-search-form]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    const precise = form.querySelector('[data-qf-search-precise]');
    if (input && precise?.checked) input.value = normalizeQuery(input.value);
  }, true);
  document.addEventListener('click', event => {
    const back = event.target.closest('[data-qf-product-back]');
    if (back && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      try {
        const previous = new URL(document.referrer);
        if (previous.origin === location.origin && window.history.length > 1) {
          event.preventDefault();
          window.history.back();
          return;
        }
      } catch (_) {
        // Without a valid store referrer, keep the native collection link.
      }
    }
    const button = event.target.closest('[data-qf-model-toggle]');
    if (button) {
      const grid = document.getElementById(button.getAttribute('aria-controls'));
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      if (!grid) return;
      grid.toggleAttribute('data-qf-expanded', expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
    }
    const removal = event.target.closest('[data-qf-size-remove]');
    if (!removal) return;
    const aliases = removal.dataset.qfSizeRemove.split('|');
    const url = new URL(window.location.href);
    const param = 'filter.v.option.taille';
    const remaining = url.searchParams.getAll(param).flatMap(value => value.split(',')).filter(value => !aliases.includes(value));
    url.searchParams.delete(param);
    url.searchParams.delete('page');
    remaining.forEach(value => url.searchParams.append(param, value));
    removal.href = url.toString();
  }, true);
})();
